export default [
  {
    path: '/facilitiesManage',
    component: () =>
      import('../pages/hotelManage/hotelNew/facilitiesManage.vue'),
    name: 'facilitiesManage',
    title: '设施服务',
    meta: {
      title: '设施服务',
    },
  },
  {
    path: '/baseAttributeManage',
    component: () =>
      import('../pages/hotelManage/hotelNew/baseAttributeManage.vue'),
    name: 'baseAttributeManage',
    title: '基本属性',
    meta: {
      title: '基本属性',
    },
  },
  {
    path: '/hotelManage',
    component: () => import('../pages/hotelManage/hotelNew/hotelManage.vue'),
    name: 'hotelManage',
    title: '酒店管理',
    meta: {
      title: '酒店管理',
    },
  },
  {
    path: '/roomConfigSetting',
    component: () =>
      import('../pages/hotelManage/hotelNew/roomConfigSetting.vue'),
    name: 'roomConfigSetting',
    title: '配置房间',
    meta: {
      title: '配置房间',
    },
  },
  {
    path: '/roomTypeManage',
    component: () => import('../pages/hotelManage/hotelNew/roomTypeManage.vue'),
    name: 'roomTypeManage',
    title: '配置房型',
    meta: {
      title: '配置房型',
    },
  },
  {
    path: '/priceConfigSetting',
    component: () =>
      import('../pages/hotelManage/hotelNew/priceConfigSetting.vue'),
    name: 'priceConfigSetting',
    title: '配置售价',
    meta: {
      title: '配置售价',
    },
  },
  {
    path: '/hotelOrderManage',
    component: () =>
      import('../pages/hotelManage/hotelNew/hotelOrderManage.vue'),
    name: 'hotelOrderManage',
    title: '订单管理',
    meta: {
      title: '订单管理',
    },
  },
  {
    path: '/occupancyMange',
    component: () => import('../pages/hotelManage/hotelNew/occupancyMange.vue'),
    name: 'occupancyMange',
    title: '入住办理',
    meta: {
      title: '入住办理',
    },
  },
  {
    path: '/leaveHotel',
    component: () => import('../pages/hotelManage/hotelNew/leaveHotel.vue'),
    name: 'leaveHotel',
    title: '离店办理',
    meta: {
      title: '离店办理',
    },
  },
]
